module.exports = __webpack_public_path__ + "img/light-Path 21@3x.6498836c.png";